import { apiService } from '../../..'
import { CreditCheckConsentStatusResponse, CreditCheckConsentRequest } from '../types'

const baseURL = '/portal/consumers/account/credit-check/consent'

export const creditCheckService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getConsentStatus: build.query<CreditCheckConsentStatusResponse, void>({
      query: () => {
        return {
          url: baseURL,
          method: 'GET',
        }
      },
      providesTags: ['CreditCheckConsentStatus'],
    }),
    updateConsentStatus: build.mutation<void, CreditCheckConsentRequest>({
      query: (request) => ({
        url: baseURL,
        method: 'POST',
        data: request,
      }),
      invalidatesTags: ['CreditCheckConsentStatus'],
    }),
  }),
})
